import { translateServerErrors, fetchJSON } from '@eventbrite/http';
import { TYPE_ERROR } from '@eventbrite/eds-notification';

import {
    BASE_URL,
    STANDARD_SERVER_ERROR,
    ORDER_ID_INVALID_ERROR,
    EMAIL_ADDRESS_INVALID_ERROR,
} from '../constants';

import { getRequestStatusSpec } from '../utils';

const GENERAL_ERROR_SPEC = {
    ORDER_ID_INVALID: () => ORDER_ID_INVALID_ERROR,
    EMAIL_ADDRESS_INVALID: () => EMAIL_ADDRESS_INVALID_ERROR,
    default: () => STANDARD_SERVER_ERROR,
};

export const postRefundRequest = ({
    attendeeEmail,
    orderId,
    additionalInformation,
    captcha,
    helpLinks,
}) =>
    fetchJSON(BASE_URL, {
        method: 'POST',
        body: JSON.stringify({
            attendeeEmail,
            orderId,
            captcha,
            additionalInformation,
        }),
    })
        .catch(
            translateServerErrors({
                ...GENERAL_ERROR_SPEC,
            }),
        )
        .then(({ status_code: statusCode }) => {
            const { message = STANDARD_SERVER_ERROR, type = TYPE_ERROR } =
                getRequestStatusSpec(helpLinks)[statusCode];

            return { message, type };
        });
